import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
import {AdfListService} from '../adf-page/services/adf-list.service';
@Component({
  selector: 'page-ac-settings',
  templateUrl: 'ac-settings.html',
  providers:[EnvDataService,AdfListService]
})
export class AcSettingsPage {
  AcCredentialsForm: FormGroup;
  AcActiveForm: FormGroup;
  public form_name: any;
  public uid: any;
  public acApiKey: any;
  public acApiUrl: any;
  public getRole: any;
  public getemail = window.localStorage.getItem("email");
  public userRole : any;
  public isDisabled:boolean = true;
  public dealGroups:any=[];
  public dealStages:any=[];
  public selecteddeal:any;
  public ACDeals:any;
  public validation_messages = {
    'acApiKey': [
        { type: 'required', message: 'Active Campaign Api Key is required.' }
    ],
    'acApiUrl': [
      { type: 'required', message: 'Active Campaign Api Url is required.' }
    ]
  }
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    private EnvDataService:EnvDataService,
    public afdService:AdfListService
  ) {
    this.loadingProvider.startLoading();
    let thiss = this;
    thiss.uid = window.localStorage.getItem("uid");
    thiss.userRole = window.localStorage.getItem("userRole");
    var docRef0 = firebase.firestore().collection("ac_credentials").doc('acCredentials_API');
    docRef0.get().then(function(doc) {
      if (doc.exists) {
        let user_data = doc.data();
        thiss.acApiKey = user_data.acApiKey;
        thiss.acApiUrl = user_data.acApiUrl;

        thiss.getAllPipeline();

      } else {
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });

    this.form_name = "eLINK Finance";
    this.AcCredentialsForm = formBuilder.group({
      acApiKey: ['', Validators.compose([Validators.required])],
      acApiUrl: ['', Validators.compose([Validators.required])]
    }); 
    //
    this.AcActiveForm = formBuilder.group({
      group: ['', Validators.compose([Validators.required])],
      stage: ['', Validators.compose([Validators.required])],
      ac_status:['', Validators.compose([Validators.required])]
    });
  }

  isFieldValid(field: string) {
    return !this.AcCredentialsForm.get(field).valid && this.AcCredentialsForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  save_credentials(){
    if(!this.AcCredentialsForm.valid){
      this.AcCredentialsForm.get('acApiKey').markAsDirty();
      this.AcCredentialsForm.get('acApiKey').markAsTouched();

      this.AcCredentialsForm.get('acApiUrl').markAsDirty();
      this.AcCredentialsForm.get('acApiUrl').markAsTouched();
    }else{
      let uid = window.localStorage.getItem("uid");
      let acApiKey = this.AcCredentialsForm.value.acApiKey;
      let acApiUrl = this.AcCredentialsForm.value.acApiUrl;
      if(uid != null){
        this.loadingProvider.startLoading();
        
        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        headers.append('Access-Control-Allow-Origin', '*' );
        headers.append('Api-Token', acApiKey );
        const requestOptions = new RequestOptions({ headers: headers });
        let postData = {
          "uid": uid,
          "acApiKey" : acApiKey,
          "acApiUrl" : acApiUrl
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/updateACCredentials";
        this.http.post(url, postData,requestOptions)
        .subscribe(data => {
          console.log(data);
          if(data['_body'] == 'success'){
            this.loadingProvider.stopLoading();
            this.isDisabled = true;
            this.presentToastSuccess('Update Credentials successfully!');            
          }else{
            this.loadingProvider.stopLoading();  
            this.presentToastSuccess(data['_body']);          
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToastmsg(error);
        });
      }
    }
  }
  getAllPipeline() {
    var headers = new Headers();
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
    headers.append('Access-Control-Allow-Origin', '*' );
    headers.append('Api-Token', this.acApiKey );
    const requestOptions = new RequestOptions({ headers: headers });
    let postData = {
      "acApiKey" : this.acApiKey,
      "acApiUrl" : this.acApiUrl
    }
    console.log(postData);
    var url = this.EnvDataService.EnvData.sendbox_api+"/allpipelines";
    this.http.post(url, postData,requestOptions)
    .subscribe(data => {
     let resdata =  JSON.parse(data['_body']);
     console.log(resdata);
     this.dealGroups = resdata.dealGroups;
     this.selecteddeal = this.dealGroups[0];
     this.AcActiveForm.get('group').setValue(this.selecteddeal.id)
     console.log(this.selecteddeal);
     this.dealStages = resdata.dealStages;
     this.getAcDetails();
     //this.loadingProvider.stopLoading();
    }, error => {
 
    });
  }
  reset_credentials() {
    this.isDisabled = false;
  }
  presentToastmsg(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }
  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ApiCredentialsPage');
  }
  onChangePipeline(event) {
    let groupid = event.target.value;
    // this.selecteddeal = event.target.value;
    this.dealGroups.forEach(element => {
      if(element.id == groupid) {
        this.selecteddeal = element;
      }
    });
    let selectedoption = [];
    this.ACDeals.forEach(element => {
      console.log(element);
      element.stage.forEach(stage => {
        selectedoption.push(stage);
       }); 
       if(element.group == groupid) {
         console.log(element);
        this.AcActiveForm.get('ac_status').setValue(element.ac_status);
       }
       
    });
    //this.ACDeals=selectedoption;
    this.AcActiveForm.get('stage').setValue(selectedoption);
    console.log(this.selecteddeal);
  }
  save_status() {
    this.loadingProvider.startLoading();
    let activeformvalue = this.AcActiveForm.value;
    this.afdService.saveActiveStatus(activeformvalue).then((data:any = []) => {
      console.log(data);
      this.loadingProvider.stopLoading();
      this.presentToastSuccess('Updated successfully!');
    });
  }
  getAcDetails() {
    this.afdService.getActiveStatus().then((data:any = []) => {
      console.log(data);
      this.ACDeals=data;
      let selectedoption = []
      data.forEach((element:any) => {
        if(element.stage) {
          element.stage.forEach(stage => {
            selectedoption.push(stage);
           });
        }
          if(element.group == "18") {
              console.log(element);
            this.AcActiveForm.get('ac_status').setValue(element.ac_status);
          }
      });
      //this.ACDeals=selectedoption;
      this.AcActiveForm.get('stage').setValue(selectedoption);
      this.loadingProvider.stopLoading();
      this.presentToastSuccess('Updated successfully!');
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/ac-settings/ac-settings.ts